import React from 'react';

import { BoxProps, Divider, Group, Stack, Title } from '@mantine/core';

export const HomepageTitle = ({
    children,
    rightSection,
    ...props
}: { children: React.ReactNode; rightSection?: React.ReactNode } & BoxProps) => {
    return (
        <Stack gap={9} {...props}>
            <Group justify="space-between" align="center">
                <Title order={2} fw={800} fz={20} ta="left">
                    {children}
                </Title>
                {rightSection}
            </Group>
            <Divider w={40} size={3} color="black" />
        </Stack>
    );
};
